import moment from 'moment'
import httpRequest from './httpRequest'
import loopback from './loopback'

const API = loopback.loopbackUrl
const pathUser = 'Employees/'
const routeLogin = API + pathUser + 'login'
const routeLogout = API + pathUser + 'logout'
const routeResetPasswordEmail = API + pathUser + 'reset'
const routeResetPassword = API + '/reset-password'

const paramAccessToken = 'access_token'

// localstorage auth token key
const LS_AUTH_TOKEN_KEY = 'esms-auth-token'
const LS_AUTH_USER_ID = 'esms-auth-user-id'
const LS_AUTH_TTL = 'esms-auth-ttl'
const LS_AUTH_CREATED = 'esms-auth-created'

function loginRequest (username, password, cb) {
    const loginResponse = {
      authenticated: false,
      auth: {}
    }
    console.log('loginrequest', username)
    return httpRequest.post(routeLogin, {
      username: username,
      password: password
    })
    .then((result) => {
      if (!('id' in result)) {
        throw new Error('token not in login response', result)
      }
      loginResponse.authenticated = true
      loginResponse.auth = result
  
      cb(loginResponse)
    })
    .catch((error) => {
      console.log('error', error)
      cb(loginResponse)
    })
}
  
function logoutRequest (token) {
    httpRequest.post(routeLogout + '?' + paramAccessToken + '=' + token)
    .then((result) => {
        console.log('logged out', result)
    })
    .catch((error) => {
        console.log('logged out error', error)
    })
}


export default {
  PARAM_ACCESS_TOKEN: paramAccessToken,

  resetPasswordEmail (email) {
    return httpRequest.post(routeResetPasswordEmail, {
      email: email
    })
  },

  resetPassword (password, accessToken) {
    const url = routeResetPassword + '?access_token=' + accessToken
    return httpRequest.post(url, {
      password: password
    })
  },

  login (email, pass, cb) {
    // cb = arguments[arguments.length - 1]
    // if (localStorage[LS_TOKEN_KEY]) {
    //   if (cb) cb(true)
    //   this.onChange(true)
    //   return
    // }
    loginRequest(email, pass, (res) => {
      if (res.authenticated) {
        localStorage[LS_AUTH_TOKEN_KEY] = res.auth.id
        localStorage[LS_AUTH_USER_ID] = res.auth.userId
        localStorage[LS_AUTH_TTL] = res.auth.ttl
        localStorage[LS_AUTH_CREATED] = res.auth.created
        if (cb) cb(res)
        this.onChange(true)
      } else {
        if (cb) cb(res)
        this.onChange(false)
      }
    })
  },

  getToken () {
    return localStorage[LS_AUTH_TOKEN_KEY]
  },

  getUserId () {
    return localStorage[LS_AUTH_USER_ID]
  },

  logout (cb) {
    if (this.loggedIn()) {
      logoutRequest(localStorage[LS_AUTH_TOKEN_KEY])
      delete localStorage[LS_AUTH_TOKEN_KEY]
      delete localStorage[LS_AUTH_USER_ID]
      delete localStorage[LS_AUTH_TTL]
      delete localStorage[LS_AUTH_CREATED]
      this.onChange(false)
    }
    if (cb) cb()
  },

  loggedIn () {
    if (!localStorage[LS_AUTH_TOKEN_KEY] || !localStorage[LS_AUTH_TTL] || !localStorage[LS_AUTH_CREATED]) {
      console.log('auth tokens not present')
      return false
    }

    // if the current time is after the created + ttl time, token is expired
    if (moment().isAfter(
          moment(localStorage[LS_AUTH_CREATED]).add(localStorage[LS_AUTH_TTL], 'seconds')
      )) {
      console.log('auth token expired')
      return false
    }

    // console.log('auth logged in')
    return true
  },

  onChange () {
      // nothing to do
  }
}


